import ImagesPallet from "../../../../../../../utils/ImagesPallet";

const OurStylistData = [
 {
  name: "Tyo",
  image: ImagesPallet.TyoCgkBranch,
  specialty: "Capster",
  experience: "5 years"
 },
 {
  name: "Arul",
  image: ImagesPallet.ArulCgkBranch,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
 {
  name: "Eky",
  image: ImagesPallet.EkyCgkBranch,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
 {
  name: "Indra",
  image: ImagesPallet.IndraCgkBranch,
  specialty: "Capster",
  experience: "10 years"
 },
 {
  name: "Andhika",
  image: ImagesPallet.AndhikaCgkBranch,
  specialty: "Capster",
  experience: "6 years"
 },
 {
  name: "Johan",
  image: ImagesPallet.JohanCgkBranch,
  specialty: "Capster",
  experience: "6 years"
 },
];

export default OurStylistData

